const LoadingService = {
  showLoader(message: string) {
    let event = new CustomEvent('showLoader', { detail: message });
    window.dispatchEvent(event);
  }
};

export default LoadingService;
